<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE LISTA DE CONTATO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="txtName"><small class="text-danger">*</small> Tipo:</label>
          <div class="input-group">
            <b-form-select v-model="form.tipo.value" :options="form.tipo.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-8">
          <label ><small v-show="form.nome.required" class="text-danger">*</small> Lista:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome da Lista'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
              :columns="['CPF/CNPJ', 'Nome', 'E-mail', 'Celular', $lang.Common.DataTable.Actions]"
              :showTipFooter="false"
              :showUpload="this.canAddContact"
              v-on:Upload="onOpenUpload"
              v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.documento" />
        <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.email ? obj.email : ''" />
        <TableColumn :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.celular ? obj.celular.toUpperCase() : ''" />
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDeleteContact(obj)" :status="obj.status" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-md-12 pl-4">
        <button v-if="segmentType === 2" type="button" class="btn btn-third btn-sm mr-2" :disabled="!canAddContact" @click="onOpenContactAdd" v-b-tooltip.hover :title="'Adicionar Contatos na Lista'">
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none"> Adicionar Contatos</span>
        </button>
        <button v-if="segmentType === 1" type="button" class="btn btn-third btn-sm" :disabled="!canAddContact" @click="onOpenAdvancedContactAdd"  v-b-tooltip.hover :title="'Adicionar Contatos de forma avançado na Lista'">
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none"> Adicionar Avançado</span>
        </button>
      </div>
    </div>
    <ModalSegmentationContact
      ref="ModalSegmentationContact"
      @created="onLoad"/>
    <ModalSegmentationAdvancedContact
      ref="ModalSegmentationAdvancedContact"
      @created="onLoad"/>
    <ModalSegmentationUploadContact
      ref="ModalSegmentationUploadContact"
      @created="onLoad"/>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import SegmentationModel from '@/shared/models/configurations/campaignlistmodel.js'
import SegmentationForms from './campaignlistadd-form.js'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'
import SegmentationContactRepository from '@/shared/http/repositories/configurations/campaignlistcontact.js'
import ModalSegmentationContact from './modal/contactmodal/contact.vue'
import ModalSegmentationAdvancedContact from './modal/advancedcontactmodal/advancedcontact.vue'
import ModalSegmentationUploadContact from './modal/uploadcontactmodal/uploadcontactmodal.vue'

export default {
  name: 'CampaignListAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: SegmentationModel,
      form: SegmentationForms,
      segment: null,
      canAddContact: false
    }
  },
  components: {
    ModalSegmentationContact,
    ModalSegmentationAdvancedContact,
    ModalSegmentationUploadContact
  },
  computed: {
    segmentType: function () {
      let result = ''
      if (this.segment && this.segment.tipo) {
        result = this.segment.tipo
      }
      return result
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.canAddContact = false
      this.$refs.tableGrid.Clear()

      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onLoad () {
      if (this.data && this.data.id) {
        loading.push()
        SegmentationContactRepository.GetAllBySegmentationPaging(this.data.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
        loading.pop()
      }
    },
    onDeleteContact (obj) {
      loading.push()
      SegmentationContactRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      loading.push()
      if (obj && obj.id) {
        this.segment = obj
        Tools.SetValueInForm(this.form, this.data, obj)
        this.form.tipo.value = obj.tipo
        this.canAddContact = true
        loading.push()
        SegmentationContactRepository.GetAllBySegmentationPaging(obj.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
        loading.pop()
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value
      SegmentationRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onEdit(response.data)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      SegmentationRepository.Update(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onOpenContactAdd () {
      this.$refs.ModalSegmentationContact.showModal(this.data.id)
    },
    onOpenAdvancedContactAdd () {
      this.$refs.ModalSegmentationAdvancedContact.showModal(this.data.id)
    },
    onOpenUpload () {
      this.$refs.ModalSegmentationUploadContact.showModal(this.data.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/campaign/campaignlist/components/add/campaignlistadd.vue